<template>
    <div class="spot" id="spot">
        <img class="spot-title" src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/spot-title.png" alt="">
        <div class="spot-content">
            <Waterfall :list="list.slice(0, scrollIndex * 20)" :gutter="isPc ? 16 : 9" :breakpoints="breakpoints" :width="itemWidth" v-if="list&&list.length>0">
                <template #item="{ item, index }">
                  <div class="pic__card">
                      <LazyImg :url="item" :key="item.eid" @click.native="itemFn(index)" />
                  </div>
                </template>
            </Waterfall>
            <div class="btn btn1" @click="moreFn" v-if="scrollIndex * 20 < total">{{ $t('more') }}</div>
        </div>
        <transition name="fade">
          <div class="stop-mask" ref="stopMask" @click="showMask = false" v-show="showMask">
            <swiper ref="stopSwiper" :options="swiperOptions" class="my-swiper" id="swiper">
              <swiper-slide v-for="(item, index) in list" :key="index" class="item">
                <img class="img" :src="activeIndex <= (index + 4) && activeIndex >= (index - 4) ? item : ''" alt="">
              </swiper-slide>
            </swiper>
            <img src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/mask-close.png" alt="" class="mask-close">
            <div class="icon-left" @click.stop="toPrev" v-if="activeIndex !== 0"></div>
            <div class="icon-right" @click.stop="toNext" v-if="activeIndex !== (list.length - 1)"></div>
          </div>
        </transition>
    </div>
</template>

<script>
import { LazyImg, Waterfall } from 'vue-waterfall-plugin'
import 'vue-waterfall-plugin/dist/style.css'

export default {
  name: 'spot',
  components: {Waterfall, LazyImg},
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    const that = this
    return {
      itemWidth: 0,
      showMask: false,
      swiperOptions: {
        onTransitionEnd: function(swiper) {
          that.activeIndex = swiper.activeIndex
        }
      },
      activeIndex: 0,
      breakpoints: {
        1200: {
          rowPerView: 3
        },
        800: {
          rowPerView: 2
        },
        500: {
          rowPerView: 2
        }
      },
      mySwiper: null,
      scrollIndex: 1,
      loading: false,
      timer: null,
      total: 0
    }
  },
  watch: {
    list: {
      handler() {
        this.total = this.list.length
      },
      deep: true
    }
  },
  mounted() {
    const dom = this.$refs.stopMask
    document.body.appendChild(dom)
    this.itemWidth = this.isPc ? Math.floor((document.getElementById('spot').offsetWidth - 48) / 4) : Math.floor((document.getElementById('spot').offsetWidth - 45) / 2)

    // window.addEventListener('scroll', e => {
    //     var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    //     const footScroll = $('#footer').offset().top - document.documentElement.clientHeight - 100
    //     this.scrollFn(scrollTop, footScroll)
    // })
  },
  methods: {
    moreFn() {
      this.scrollIndex++
    },
    // scrollFn(scrollTop, footScroll) {
    //   if (scrollTop > footScroll && !this.loading) {
    //       this.scrollIndex++
    //       this.loading = true

    //       clearTimeout(this.timer)
    //       this.timer = setTimeout(() => {
    //         this.loading = false
    //         // this.scrollFn(scrollTop, footScroll)
    //       }, 1000)
    //   }
    // },
    itemFn(index) {
      this.activeIndex = index
      this.showMask = true
      this.$nextTick(() => {
        this.$refs.stopSwiper.$el.swiper.slideTo(index)
      })
    },
    toPrev() {
      this.$refs.stopSwiper.$el.swiper.slidePrev()
    },
    toNext() {
      this.$refs.stopSwiper.$el.swiper.slideNext()
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 768px) {
    .spot-title {
        margin: 120px 0 12px;
        width: auto;
        height: 70px;
    }

    .spot-content {
      margin-left: -16px;
      margin-right: -16px;

      .btn {
          width: 148px;
          height: 40px;
          background: rgba(22, 80, 255, 0.6);
          border-radius: 20px;
          margin: 60px auto 0;
          font-family: AlibabaPuHuiTi_3_45_Light;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 22px;
          font-style: normal;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: .3s;

          &:hover {
              width: 164px;
          }
      }

      /deep/ .waterfall-list {
        background: none !important;
        
        .lazy__resource {
          position: relative;
          border-radius: 12px;
          cursor: pointer;
          transition: .3s;
          overflow: hidden;

          &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              border-radius: 12px;
              border: 1px solid #1650FF;
              z-index: 10;
          }

          .lazy__img {
              border-radius: 12px;
              transition: .5s;
          }

          &:hover {
            .lazy__img {
              transform: scale(1.05);
            }
          }

          &:hover::before {
              border: 2px solid #4D84FF;
          }
        }
      }
    }

    .stop-mask {
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: #000;
      z-index: 9999;

      .my-swiper {
        width: calc(100% - 296px);
        height: 100%;
        margin: 0 auto;

        .img {
          width: 100%;
          height: 100vh;
          background-size: contain;
          background-position: center center;
          background-repeat: no-repeat;
          object-fit: contain;
        }
      }

      .mask-close {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 40px;
        height: 40px;
        cursor: pointer;
      }

      .icon-left {
        position: absolute;
        left: 40px;
        top: calc(50% - 34px);
        width: 68px;
        height: 68px;
        background-image: url(https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/icon-left.png);
        background-size: 100% 100%;
        cursor: pointer;

        &:hover {
          background-image: url(https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/icon-right.png);
          transform: rotate(180deg);
        }
      }

      .icon-right {
        position: absolute;
        right: 40px;
        top: calc(50% - 34px);
        width: 68px;
        height: 68px;
        background-image: url(https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/icon-left.png);
        transform: rotate(180deg);
        background-size: 100% 100%;
        cursor: pointer;

        &:hover {
          background-image: url(https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/icon-right.png);
          transform: rotate(0deg);
        }
      }
    }
}
@media screen and (max-width: 767px) {
    .spot-title {
        margin: 50px 0 0;
        width: 160px;
        height: auto;
    }

    .spot-content {
      margin-left: -9px;
      margin-right: -9px;

      .btn {
          width: 148px;
          height: 40px;
          background: rgba(22, 80, 255, 0.6);
          border-radius: 20px;
          margin: 20px auto 0;
          font-family: AlibabaPuHuiTi_3_45_Light;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 22px;
          font-style: normal;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
      }

      /deep/ .waterfall-list {
        background: none !important;
        width: 100%;

        .lazy__img {
          border-radius: 6px;
          border: 1px solid #1650FF;
        }
      }
    }

    .stop-mask {
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: #000;
      z-index: 9999;
      display: flex;
      align-items: center;

      .my-swiper {
        width: 100%;
        height: calc(100vh - 5rem);

        .img {
          width: 100%;
          height: 100%;
          background-size: contain;
          background-position: center center;
          background-repeat: no-repeat;
          object-fit: contain;
        }
      }

      .mask-close {
        position: absolute;
        right: .2rem;
        top: 1.2rem;
        width: .6rem;
        height: .6rem;
        cursor: pointer;
      }

      .icon-left {
        display: none;
        position: absolute;
        left: 40px;
        top: calc(50% - 34px);
        width: 68px;
        height: 68px;
        background-image: url(https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/icon-left.png);
        background-size: 100% 100%;
        cursor: pointer;

        &:hover {
          background-image: url(https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/icon-right.png);
          transform: rotate(180deg);
        }
      }

      .icon-right {
        display: none;
        position: absolute;
        right: 40px;
        top: calc(50% - 34px);
        width: 68px;
        height: 68px;
        background-image: url(https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/icon-left.png);
        transform: rotate(180deg);
        background-size: 100% 100%;
        cursor: pointer;

        &:hover {
          background-image: url(https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/icon-right.png);
          transform: rotate(0deg);
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/spot.vue